export default {
  notablePlayersMap: {
    // PLAYERS WITH PICTURES
    'rayman200': {
      imageURL: 'img/playerImage/rayman.png',
      facts: [
       '3x D1 Catan Champs Champion',
       '1v1 World Cup Champion',
       '#1 in Season 6', // Base
       '#3 in Season 6', // 1v1
       '#2 in Season 7', // 1v1
       '#4 in Season 8', // 1v1
       '#1 in Season 9', // 1v1
       '#13 in Season 11', // 1v1
      ]
    },
    'rayman147': {
      imageURL: 'img/playerImage/rayman.png',
      facts: [
        '#4 in Season 8', // 1v1
        '#2 in Season 7', // 1v1
        '3x D1 Catan Champs Champion',
        '1v1 World Cup Champion',
        '#1 in Season 6', // Base
        '#3 in Season 6', // 1v1
        '#1 in Season 9', // 1v1
        '#13 in Season 11', // 1v1
       ]
    },
    'KillaKarisma': {
      imageURL: 'img/playerImage/killaKarisma.jpg',
      facts: [
      '#1 and #2 in Season 8', // 1v1
      '#1 in Season 7', // 1v1
       'Reigning 1v1 Champion',
       'Rank #16 in Season 6', // Base
       '#9 in Season 6', // 1v1
       '#11 in Season 7', // Base
       '#1 in Season 7', // 1v1
       '#1 and #2 in Season 8', // 1v1
       '#4 in Season 9', // 1v1
       '#26 in Season 10', // 1v1
       '#1 in Season 11', // 1v1
      ]
    },
    'urNightmare': {
      alias: 'KillaKarisma'
    },
    'blast247': {
      alias: 'KillaKarisma'
    },
    'ThePhantom': {
      imageURL: 'img/playerImage/thePhantom.jpg',
      facts: [
        '#19 in Season 8', // 1v1
        '#26 in Season 7', // 1v1
        '#2 in Season 9', // 1v1
        '#17 in Season 10', // 1v1
        '#31 in Season 11', // 1v1
        '1v1 World Cup Quarter-finalist',
        'Catan Youtuber - 10k subs'
      ]
    },
    'itsOKK': {
      imageURL: 'img/playerImage/itsOkk.jpg',
      facts: [
        '#21 in Season 11', // 1v1
        '#101 in Season 10', // 1v1
        '#68 in Season 9', // 1v1
        'Catan Youtuber - 700 subs'
      ]
    },
    'S1mplyCatan': {
      imageURL: 'img/playerImage/simplyCatan.jpg',
      facts: [
        '#9 in Season 11', // 1v1
        'Catan Youtuber'
      ]
    },
    'DandyDrew': {
      imageURL: 'img/playerImage/dandyDrew.jpg',
      facts: [
        '2024 USA National Champion',
        'Catan Youtuber - 26k subs',
        'Rank #16 in Season 10', // Base
        'Major League Catan Participant',
      ]
    },
    'Dylighted': {
      imageURL: 'img/playerImage/dylighted.jpg',
      facts: [
        'Rank #6 in Season 6', // Base
        'Rank #1 Catan Youtuber - 71k subs',
        'Major League Catan Participant',
      ]
    },
    'HughYoutube': {
      imageURL: 'img/playerImage/hughYoutube.jpg',
      facts: [
        'Catan Youtuber - 2.5k subs',
        'Rank #14 in Season 10', // Base
        'Rank #120 in Season 9', // Base
        'Rank #7 in Season 6', // Base
      ]
    },
    'md7': {
      imageURL: 'img/playerImage/md7.png',
      facts: [
        '#13 in Season 8', //Base
        '2x D1 Catan Champs Champion',
        'Major League Catan Participant',
        '#29 in Season 7', //Base
        '#1 in Season 9', //Base
        '#1 in Season 11', //Base
      ]
    },
    'swheatchick': {
      alias: 'md7'
    },
    'PizzaPenguin': {
      imageURL: 'img/playerImage/cheesEmperor.png',
      facts: [
        '#55 in Season 7', //Base
        '#73 in Season 10', //Base
        '#4 in Season 11', //Base
      ]
    },
    'tavaline': {
      imageURL: 'img/playerImage/tavaline.png',
      facts: [
        'Rank #106 in Season 4', //Base
        '1x D2 Catan Champs Champion',
        'Rank #2 in Season 7', //Base
      ]
    },
    'AngryRobin': {
      imageURL: 'img/playerImage/angryRobin.jpg',
      facts: [
        'Rank #8 in Season 6', //Base
        'Rank #7 in Season 7', //Base
        'Major League Catan Participant'
      ]
    },
    'Ghajni': {
      imageURL: 'img/playerImage/ghajni.png',
      facts: [
        'Rank #1 in Season 6',
        'Rank #1 in Season 1'
      ]
    },
    'Sinless': {
      imageURL: 'img/playerImage/sinless.jpg',
      facts: [
        'Catan Champs Div 1 Champion',
        'Rank #541 in Season 7',
      ]
    },
    // PLAYERS WITHOUT PICTURES
    'progamer777': {
      facts: [
        'Rank #63 in Season 7', //1v1
      ]
    },
    'BootlessBill': {
      facts: [
        'Rank #92 in Season 5', //Base
        'Rank #17 in Season 6', //Base
        'Rank #8 in Season 7', //Base
        'Rank #27 in Season 8', //Base
        'Rank #16 in Season 9', //Base
        'Rank #27 in Season 10', //Base
      ]
    },
    'CatanCatan91': {
      facts: [
        'Rank #288 in Season 6', //Base
        'Rank #7 in Season 4', //Base
        '#1 in Season 7', //Base
      ]
    },
    'VeeMars': {
      facts: [
        'Rank #6 in Season 6', //Base
        '',
        '#65 in Season 7', //Base
      ]
    },
    'ManGuy': {
      facts: [
        'Rank #14 in Season 6', //Base
        ''
      ]
    },
    'Lion2': {
      facts: [
        'Catan Champs Div 2 Semifinalist',
        'Rank #209 in Season 7', //Base
      ]
    },
    'Waimea': {
      facts: [
        'Rank #170 in Season 7', //Base
        ''
      ]
    },
    'coldwar': {
      facts: [
        'Rank #177 in Season 7', //Base
      ]
    },
    'RF20': {
      facts: [
        'Rank #192 in Season 7',
        'Rank #450 in Season 6', //Base
      ]
    },
    'Mohsen7605': {
      facts: [
        'Rank #32 in Season 7', //Base
        'Rank #1027 in Season 6', //Base
      ]
    },
    'azamat2': {
      facts: [
        'Rank #24 in Season 7',
        'Rank #1200 in Season 6', //Base
      ]
    },
    'StayingMad': {
      facts: [
        'Rank #19 in Season 7',
        'Rank #14 in Season 6',
      ]
    },
    'Cost5916': {
      facts: [
        'Rank #119 in Season 8'
      ]
    },
    'BurgIdentity': {
      facts: [
        'Rank #61 in Season 8',
        'Rank #38 in Season 7',
      ]
    },
    'Maggie8293': {
      facts: [
        'Rank #6 in Season 8',
        'Rank #96 in Season 7',
      ]
    },
    'Kwan9826': {
      facts: [
        'Rank #463 in Season 8'
      ]
    },
    'Derse': {
      facts: [
        'Rank #83 in Season 8',
        'Rank #41 in Season 7',
      ]
    },
    'SirJustice': {
      facts: [
        'Rank #165 in Season 8',
        'Rank #226 in Season 7',
      ]
    },
    'Biddy': {
      facts: [
        'Rank #25 in Season 8',
        'Rank #371 in Season 6',
      ]
    },
    'stampede': {
      facts: [
        'Rank #129 in Season 8',
        'Rank #19 in Season 7',
      ]
    },
    'Maxpain': {
      facts: [
        'Rank #23 in Season 8',
        'Rank #2 in Season 6',
      ]
    },
    'JWEEZY': {
      facts: [
        'Rank #10 in Season 8',
        'Rank #135 in Season 7',
      ]
    },
    'wonder2792': {
      facts: [
        'Rank #106 in Season 8',
        'Rank #1067 in Season 7',
      ]
    },
    'snackjar': {
      facts: [
        'Rank #204 in Season 8'
      ]
    },
    'trailerrrr': {
      facts: [
        'Rank #21 in Season 8',
        'Rank #181 in Season 7',
      ]
    },
    'Robijs': {
      facts: [
        'Rank #28 in Season 7',
        'Rank #149 in Season 6',
      ]
    },
    'Giangi503': {
      facts: [
        'Rank #91 in Season 8',
        'Rank #150 in Season 7',
      ]
    },
    'Colih': {
      facts: [
        'Rank #37 in Season 6',
        'Rank #317 in Season 5',
      ]
    },
  },
  testHallOfFameLeaderboard : [
    {rank: 1, name: 'Dashed', value: 4},
    {rank: 2, name: 'KillaKarisma', value: 3},
    {rank: 3, name: 'Ghajni', value: 2},
    {rank: 4, name: 'Derse', value: 1},
    {rank: 5, name: 'Hawkeye', value: 1},
    {rank: 6, name: 'itsOKK', value: 1},
    {rank: 7, name: 'Rayman200', value: 1},
    {rank: 8, name: 'ThePhantom', value: 0},
    {rank: 9, name: 'DudeNolann', value: 0},
    {rank: 10, name: 'Griff1n', value: 0},
    {rank: 11, name: 'Eyesick', value: 0},
    {rank: 12, name: 'Karmo', value: 0},
    {rank: 13, name: 'TofuTyrant', value: 0},
    {rank: 14, name: 'Squashhh', value: 0},
  ]
};